//Images :
import balanceImg from "../images/balance.jpg";
import belierImg from "../images/belier.jpg";
import cancerImg from "../images/cancer.jpg";
import capricorneImg from "../images/capricorne.jpg";
import gemeauxImg from "../images/gemeaux.jpg";
import lionImg from "../images/lion.jpg";
import poissonImg from "../images/poisson.jpg";
import sagitaireImg from "../images/sagitaire.jpg";
import scorpionImg from "../images/scorpion.jpg";
import taureauImg from "../images/taureau.jpg";
import verseauImg from "../images/verseau.jpg";
import viergeImg from "../images/vierge.jpg";

export const signs = [
  {
    sign: "Poisson",
    image: poissonImg,
    englishName: "Pisces",
  },
  {
    sign: "Bélier",
    image: belierImg,
    englishName: "Aries",
  },
  {
    sign: "Verseau",
    image: verseauImg,
    englishName: "Aquarius",
  },
  {
    sign: "Taureau",
    image: taureauImg,
    englishName: "Taurus",
  },
  {
    sign: "Capricorne",
    image: capricorneImg,
    englishName: "Capricorn",
  },
  {
    sign: "Gémeaux",
    image: gemeauxImg,
    englishName: "Gemini",
  },
  {
    sign: "sagitaire",
    image: sagitaireImg,
    englishName: "Sagittarius",
  },
  {
    sign: "cancer",
    image: cancerImg,
    englishName: "Cancer",
  },
  {
    sign: "Balance",
    image: balanceImg,
    englishName: "Libra",
  },
  {
    sign: "Scorpion",
    image: scorpionImg,
    englishName: "Scorpio",
  },
  {
    sign: "Vierge",
    image: viergeImg,
    englishName: "Virgo",
  },
  {
    sign: "Lion",
    image: lionImg,
    englishName: "Leo",
  },
];
